// actions.js
import {
  FETCH_CATEGORIES_REQUEST,
  FETCH_CATEGORIES_SUCCESS,
  FETCH_CATEGORIES_FAILURE,
  DELETE_CATEGORIES_REQUEST,
  DELETE_CATEGORIES_FAILURE,
  DELETE_CATEGORIES_SUCCESS,
  FETCH_CATEGORY_REQUEST,
  FETCH_CATEGORY_SUCCESS,
  FETCH_CATEGORY_FAILURE,
  UPDATE_CATEGORIES_REQUEST,
  UPDATE_CATEGORIES_SUCCESS,
  UPDATE_CATEGORIES_FAILURE,
  CLEAR_CATEGORY_ERRORS,
  CLEAR_CATEGORY_SUCCESS,
} from './actionTypes';

export const fetchCategoriesRequest = () => ({
  type: FETCH_CATEGORIES_REQUEST,
});

export const fetchCategoriesSuccess = (projects) => ({
  type: FETCH_CATEGORIES_SUCCESS,
  payload: projects,
});

export const fetchCategoriesFailure = (error) => ({
  type: FETCH_CATEGORIES_FAILURE,
  payload: error,
});

export const fetchCategoryRequest = (id) => ({
  type: FETCH_CATEGORY_REQUEST,
  payload: id
});

export const fetchCategorySuccess = (project) => ({
  type: FETCH_CATEGORY_SUCCESS,
  payload: project,
});

export const fetchCategoryFailure = (error) => ({
  type: FETCH_CATEGORY_FAILURE,
  payload: error,
});

export const updateCategoryRequest = (project, navigate) => ({
  type: UPDATE_CATEGORIES_REQUEST,
  payload: { project, navigate }
});

export const updateCategorySuccess = () => ({
  type: UPDATE_CATEGORIES_SUCCESS,
});

export const updateCategoryFailure = (error) => ({
  type: UPDATE_CATEGORIES_FAILURE,
  payload: error,
});

export const deleteCategoryRequest = (id) => ({
  type: DELETE_CATEGORIES_REQUEST,
  payload: id
});

export const deleteCategorySuccess = (id) => ({
  type: DELETE_CATEGORIES_SUCCESS,
  payload: id,
});

export const deleteCategoryFailure = (error) => ({
  type: DELETE_CATEGORIES_FAILURE,
  payload: error,
});

export const clearCategoryErrors = () => ({
  type: CLEAR_CATEGORY_ERRORS,
});

export const clearCategorySuccess = () => ({
  type: CLEAR_CATEGORY_SUCCESS,
});